const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const MeasuredEl = require("./MeasuredEl");
const CanvasView = require("./Canvas");
const DemoEmailModal = require("./DemoEmailModal");
const DemoTutorialModal = require("./DemoTutorialModal");
const OctagonalButton = require("./OctagonalButton");
const DrawingUtil = require("../util/DrawingUtil");
const URLMake = require("../../../shared/URLMake");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AssetsUtil = require("../util/AssetsUtil");
const AT = require("../vault/ActionTypes");
const {atDemo} = require("../vault/StateCursors");
const Sounds = require("../util/Sounds");
const Analytics = require("../util/Analytics");

const styles = require("./styles/DemoBar.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		demoTutorialType: atDemo(vaultState).getIn("showing"),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "demoBar",

		propTypes: {
			isExpandable: PT.bool,

			// Injected by HOCs
			demoTutorialType: PT.string,
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			showDemoEmailSignUpModal: function(type) {
				this.setState({showEmailModal: true});
			},
		},

		getInitialState: function() {
			return {
				showEmailModal: false,
			};
		},

		handleClickLearnMore: function() {
			Sounds.playSound("lesson-menu");
			Analytics.sendEvent(
				"Demo Interaction",
				"button click",
				"top bar - learn more"
			);
			this.props.dispatch({
				type: AT.CLOSE_DEMO_TUTORIAL,
			});
			this.setState({showEmailModal: true});
			this.props.dispatch({
				type: AT.OPEN_DEMO_LEARN_MORE_MODAL,
			});
		},

		handleClickEnrollNow: function() {
			// actual link is handled by an anchor
			Sounds.playSound("lesson-menu");
			Analytics.sendEvent(
				"Demo Interaction",
				"button click",
				"top bar - enroll now"
			);
		},

		handleCloseLearnMoreModal: function() {
			this.setState({showEmailModal: false});
			this.props.dispatch({
				type: AT.CLOSE_DEMO_EMAIL_SIGN_UP_MODAL,
			});
		},

		render: function() {
			const secondaryMask =
				this.props.demoTutorialType &&
				this.props.demoTutorialType !== "home2ndVisit" ? (
					<img
						className={styles.topBarMask}
						src={AssetsUtil.getTopBar("mask")}
					/>
				) : null;
			const drawDemoBar = context => {
				context.clearRect(0, 0, context.getWidth(), context.getHeight());
				DrawingUtil.drawDemoBar(
					context,
					{
						x: 0,
						y: 0,
						w: Math.floor(context.getWidth()),
						h: Math.floor(
							context.getHeight() / (this.props.isExpandable ? 1.5 : 1)
						),
					},
					this.props.isExpandable
				);
			};
			const mainClass = this.props.isExpandable ? styles.withWart : styles.main;

			return (
				<div>
					{secondaryMask}
					<div className={styles.container}>
						<MeasuredEl className={mainClass}>
							<CanvasView draw={drawDemoBar} />
						</MeasuredEl>
						<OctagonalButton
							className={styles.learnMore}
							buttonText={"LEARN MORE"}
							handleClick={this.handleClickLearnMore}
						/>
						<OctagonalButton
							className={styles.enrollNow}
							linkTo={URLMake.forEnroll()}
							buttonText={"ENROLL NOW"}
							handleClick={this.handleClickEnrollNow}
						/>
						<DemoEmailModal
							onClose={this.handleCloseLearnMoreModal}
							modalShown={this.state.showEmailModal}
						/>
						<DemoTutorialModal
							modalTypeShown={this.props.demoTutorialType || ""}
						/>
					</div>
				</div>
			);
		},
	})
);
